var incognitoTest, polyfillStore, tracky;

tracky = require('../../../core/frontend/groupon_modules/trackEvent');


/*
 * In-memory mock for local / sessionStorage
 * It is not persistent across pages.
 */

polyfillStore = function() {
  Storage.prototype._data = {};
  Storage.prototype.setItem = function(id, val) {
    return this._data[id] = String(val);
  };
  Storage.prototype.getItem = function(id) {
    if (this._data.hasOwnProperty(id)) {
      return this._data[id];
    } else {
      return null;
    }
  };
  Storage.prototype.removeItem = function(id) {
    return delete this._data[id];
  };
  Storage.prototype.clear = function() {
    return this._data = {};
  };
};


/*
 * Tries to use the sessionStorage setter, which fails in Safari incognito
 *
 * @param {String} env - SLS environment (desktop, touch, M16) to pass to tracky event
 */

incognitoTest = function(env) {
  var ref, ref1;
  if (env == null) {
    env = 'desktop';
  }
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
      sessionStorage.setItem('incognitotest', 'test');
    }
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref = Groupon.PageFlags) != null) {
        ref.isIncognito = false;
      }
    }
  } catch (error) {
    tracky("ls-likely-incognito-session-" + env);
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref1 = Groupon.PageFlags) != null) {
        ref1.isIncognito = true;
      }
    }
    polyfillStore();
  }
};

module.exports = {
  incognitoTest: incognitoTest,
  polyfillStore: polyfillStore
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvaW5jb2duaXRvLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2luY29nbml0by5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFBLEdBQVMsT0FBQSxDQUFRLG1EQUFSOzs7QUFFVDs7Ozs7QUFJQSxhQUFBLEdBQWdCLFNBQUE7RUFDZCxPQUFPLENBQUEsU0FBRSxDQUFBLEtBQVQsR0FBaUI7RUFDakIsT0FBTyxDQUFBLFNBQUUsQ0FBQSxPQUFULEdBQW1CLFNBQUMsRUFBRCxFQUFLLEdBQUw7V0FBYSxJQUFJLENBQUMsS0FBTSxDQUFBLEVBQUEsQ0FBWCxHQUFpQixNQUFBLENBQU8sR0FBUDtFQUE5QjtFQUNuQixPQUFPLENBQUEsU0FBRSxDQUFBLE9BQVQsR0FBbUIsU0FBQyxFQUFEO0lBQVEsSUFBRyxJQUFJLENBQUMsS0FBSyxDQUFDLGNBQVgsQ0FBMEIsRUFBMUIsQ0FBSDthQUFzQyxJQUFJLENBQUMsS0FBTSxDQUFBLEVBQUEsRUFBakQ7S0FBQSxNQUFBO2FBQTBELEtBQTFEOztFQUFSO0VBQ25CLE9BQU8sQ0FBQSxTQUFFLENBQUEsVUFBVCxHQUFzQixTQUFDLEVBQUQ7V0FBUSxPQUFPLElBQUksQ0FBQyxLQUFNLENBQUEsRUFBQTtFQUExQjtFQUN0QixPQUFPLENBQUEsU0FBRSxDQUFBLEtBQVQsR0FBaUIsU0FBQTtXQUFHLElBQUksQ0FBQyxLQUFMLEdBQWE7RUFBaEI7QUFMSDs7O0FBT2hCOzs7Ozs7QUFLQSxhQUFBLEdBQWdCLFNBQUMsR0FBRDtBQUNkLE1BQUE7O0lBRGUsTUFBTTs7QUFDckI7O01BQ0UsY0FBYyxDQUFFLE9BQWhCLENBQXdCLGVBQXhCLEVBQXlDLE1BQXpDOzs7O1dBQ2tCLENBQUUsV0FBcEIsR0FBa0M7O0tBRnBDO0dBQUEsYUFBQTtJQUlFLE1BQUEsQ0FBTyw4QkFBQSxHQUFnQyxHQUF2Qzs7O1lBQ2tCLENBQUUsV0FBcEIsR0FBa0M7OztJQUNsQyxhQUFBLENBQUEsRUFORjs7QUFEYzs7QUFVaEIsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDZixlQUFBLGFBRGU7RUFFZixlQUFBLGFBRmUifQ==
